/** Group category SSOT labels — ko/en/vi/ru (group.category.*) */

const category = {
  all: ['전체', 'All', 'Tất cả', 'Все'],
  expat: ['교민/친목', 'Expat / social', 'Cộng đồng / giao lưu', 'Экспаты / общение'],
  sports: ['운동/스포츠', 'Sports', 'Thể thao', 'Спорт'],
  learning: ['언어교환', 'Language exchange', 'Trao đổi ngôn ngữ', 'Языковой обмен'],
  study: ['스터디/학습', 'Study', 'Học tập', 'Учёба'],
  food: ['맛집탐방', 'Food & dining', 'Ẩm thực', 'Еда и рестораны'],
  culture: ['문화/예술', 'Culture & arts', 'Văn hóa & nghệ thuật', 'Культура и искусство'],
  religion: ['종교/신앙', 'Faith', 'Tín ngưỡng', 'Вера'],
  support: ['정보/생활', 'Info & daily life', 'Thông tin & đời sống', 'Инфо и быт'],
  general: ['일반', 'General', 'Chung', 'Общее'],
};

function pick(map, langIndex) {
  const out = {};
  Object.entries(map).forEach(([k, arr]) => {
    out[k] = arr[langIndex];
  });
  return out;
}

function buildLang(langIndex) {
  return { group: { category: pick(category, langIndex) } };
}

export const phaseGroupCategoriesKo = buildLang(0);
export const phaseGroupCategoriesEn = buildLang(1);
export const phaseGroupCategoriesVi = buildLang(2);
export const phaseGroupCategoriesRu = buildLang(3);
